import { useContext } from 'react';

import { BehaviourContext } from './behaviour.context';

export const useBehaviour = () => {
  const behaviour = useContext(BehaviourContext);
  return behaviour;
};
